var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrench = function SvgWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.271 33.354c-.459-1.28 3.512 2.259 7.566 6.266l.518.514.517.517.513.518c4.006 4.056 7.541 8.026 6.261 7.56L18.562 77.813A10.887 10.887 0 0 1 10.875 81C4.869 81 0 76.131 0 70.125c0-2.882 1.153-5.653 3.187-7.687ZM11.5 65a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M54.375 51.25C68.533 51.25 80 39.783 80 25.625c0-2.45-.352-4.82-.993-7.079-.496-1.73-2.627-2.114-3.892-.849l-12.3 12.3c-.48.48-1.137.753-1.81.753h-9.193a2.57 2.57 0 0 1-2.562-2.562v-9.193c0-.673.272-1.33.753-1.81l12.3-12.3c1.265-1.265.865-3.396-.85-3.892A25.884 25.884 0 0 0 54.376 0C40.217 0 28.75 11.467 28.75 25.625c0 3.059.545 6.006 1.521 8.729 1.337 3.264 3.413 6.303 6.228 9.119 2.815 2.815 5.865 4.9 9.147 6.256a25.448 25.448 0 0 0 8.729 1.521"
  }))));
};
export default SvgWrench;